/** Application version. Single source of truth: package.json "version", injected at build time by Vite. */
export const APP_VERSION: string = __APP_VERSION__;

/** Display form used in the UI: "V1.9.0" in production, "V1.9.0 Preview" on a development Preview (core/versionLabel). */
export const APP_VERSION_LABEL: string = __APP_VERSION_LABEL__;
